import { useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import HttpContext from "core/utils/httpContext";

function isInternalUrl(url) {
  return url.startsWith("/") && !url.startsWith("//");
}

/**
 * Редирект на другой адрес. На сервере отдаём редирект через HttpContext,
 * в браузере заменяем текущую запись истории: иначе «Назад» возвращает на
 * редиректящий адрес (пустой экран) и снова уводит вперёд.
 * permanent: на сервере 301 вместо 302.
 */
export default function ArenaRedirect({ url, permanent = false }) {
  let context = useContext(HttpContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!process.browser || !url) return;

    if (isInternalUrl(url)) {
      navigate(url, { replace: true });
    } else {
      document.location.replace(url);
    }
  }, [url, navigate]);

  if (!url) return null;

  context.url = url;

  if (permanent) {
    context.status = 301;
  }

  return null;
}

ArenaRedirect.propTypes = {
  url: PropTypes.string,
  permanent: PropTypes.bool,
};
